import { ApiClientInstance } from '@shared/api';

import { TCreateTicketRequest, TFeedbackRequest } from './type';

export const addTicket = (data: TCreateTicketRequest) =>
  ApiClientInstance.post<TCreateTicketRequest, void>('v2/support/tickets', data);

export const addFeedback = (data: TFeedbackRequest) =>
  ApiClientInstance.post<TFeedbackRequest, void>('v2/support/feedback', data);
